/* eslint-disable @typescript-eslint/no-explicit-any */
import { SEARCH_HISTORY_MAX_COUNT } from '~/constants';
import { NestedSearch } from '@habity/types';
import { persist } from 'zustand/middleware';
import { create } from 'zustand';
import isEqual from 'lodash/isEqual';
import { omitNullKeys } from '~/lib/utils';

export interface SearchHistoryProps {
  searchHistory: Partial<NestedSearch>[];
}

export interface SearchHistoryState extends SearchHistoryProps {
  addToSearchHistory: (searchQuery: Partial<NestedSearch> | null) => void;
  clearSearchHistory: () => void;
}

const DEFAULT_PROPS: SearchHistoryProps = {
  searchHistory: [],
};

export const useSearchHistoryStore = create<SearchHistoryState>()(
  persist(
    (set, get) => ({
      ...DEFAULT_PROPS,
      addToSearchHistory: (searchQuery) => {
        if (omitNullKeys(searchQuery) === null) return;
        const { searchHistory } = get();
        // Remove duplicates
        const index = searchHistory.findIndex((item) =>
          isEqual(item, searchQuery)
        );
        if (index > -1) searchHistory.splice(index, 1);
        // Remove oldest if max count reached
        if (searchHistory.length > SEARCH_HISTORY_MAX_COUNT)
          searchHistory.shift();
        set({
          searchHistory: [...searchHistory, { ...searchQuery }],
        });
      },
      clearSearchHistory: () => {
        set({ searchHistory: [] });
      },
    }),
    {
      name: 'habity-search-history',
    }
  )
);
